import {ReactComponent as Icon} from '@image/icon_alarm.svg';

const IconAlarm = () => {
    return   <Icon />;
};

export default IconAlarm;